var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REACT_NATIVE_VERSION = void 0;
exports.hasProperty = hasProperty;
exports.isFabric = isFabric;
exports.isJestEnv = isJestEnv;
exports.isRemoteDebuggingEnabled = isRemoteDebuggingEnabled;
exports.tagMessage = tagMessage;
exports.toArray = toArray;
exports.withPrevAndCurrent = withPrevAndCurrent;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _package = _interopRequireDefault(require("react-native/package.json"));
var _pack$version$split = _package.default.version.split("."), _pack$version$split2 = (0, _slicedToArray2.default)(_pack$version$split, 2), majorStr = _pack$version$split2[0], minorStr = _pack$version$split2[1];
var REACT_NATIVE_VERSION = exports.REACT_NATIVE_VERSION = {
    major: parseInt(majorStr, 10),
    minor: parseInt(minorStr, 10)
};
function toArray(object) {
    if (!Array.isArray(object)) {
        return [
            object
        ];
    }
    return object;
}
function withPrevAndCurrent(array, mapFn) {
    var previousArr = [
        null
    ];
    var currentArr = (0, _toConsumableArray2.default)(array);
    var transformedArr = [];
    currentArr.forEach(function(current, i) {
        var previous = previousArr[i];
        var transformed = mapFn(previous, current);
        previousArr.push(transformed);
        transformedArr.push(transformed);
    });
    return transformedArr;
}
function hasProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
function isJestEnv() {
    return hasProperty(global, "process") && !!process.env.JEST_WORKER_ID;
}
function tagMessage(msg) {
    return "[react-native-gesture-handler] ".concat(msg);
}
function isFabric() {
    var _global;
    return !!((_global = global) != null && _global.nativeFabricUIManager);
}
function isRemoteDebuggingEnabled() {
    return !global.nativeCallSyncHook || global.__REMOTEDEV__;
}
